import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type UseWeightClassesListQueryParams = Parameters<typeof SSF.api.weightClassesList>[0];

export const keys = createQueryKeySet<UseWeightClassesListQueryParams>('weight_classes');

export function useWeightClassesListQuery(params?: UseWeightClassesListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.weightClassesList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
